import {
  CATEGORY_LABELS,
  ICON_LEGEND,
  IconLegendCategory,
  IconLegendEntry,
} from '@/config/iconLegend';

const CATEGORY_ORDER: IconLegendCategory[] = [
  'badge',
  'project-status',
  'project-attribute',
  'rewards',
];

function groupByCategory(entries: IconLegendEntry[]) {
  const grouped: Record<IconLegendCategory, IconLegendEntry[]> = {
    badge: [],
    'project-status': [],
    'project-attribute': [],
    rewards: [],
  };
  entries.forEach((entry) => {
    grouped[entry.category].push(entry);
  });
  return grouped;
}

function IconLegend() {
  const grouped = groupByCategory(ICON_LEGEND);

  return (
    <div
      className="max-w-4xl mx-auto p-6 pb-24"
      style={{ marginTop: 'var(--nav-height)' }}
    >
      <header className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Icon Legend</h1>
        <p className="text-gray-600">
          A reference for every badge and visual icon used across Filefinity.
          Hover or tap any icon in the app to see its meaning — every tooltip
          uses the same descriptions you see here.
        </p>
      </header>

      {CATEGORY_ORDER.map((category) => {
        const items = grouped[category];
        if (!items || items.length === 0) return null;
        return (
          <section key={category} className="mb-10">
            <h2 className="text-xl font-semibold mb-4 border-b pb-2">
              {CATEGORY_LABELS[category]}
            </h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {items.map((entry) => (
                <li
                  key={entry.key}
                  className="flex gap-4 items-center p-4 border rounded-lg bg-white"
                >
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                    {entry.render(40)}
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold">{entry.name}</div>
                    <p className="text-sm text-gray-600">{entry.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}

export default IconLegend;
